<script>
import { circuitComputed, authComputed } from '@state/helpers';
export default {
  components: {},
  props: {
    items: {
      type: Array,
      required: true,
      default: null,
    },
    showIcon: {
      type: Boolean,
      required: false,
    },
    showThumbnail: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      placeholder: require('@assets/images/placeholder-exercises-list.svg'),
      selectedIndex: null,
    };
  },
  computed: {
    ...circuitComputed,
    ...authComputed,
    thumbnailPhoto() {
      return this.item &&
        this.item.mediaAssets &&
        this.item.mediaAssets.thumbnailPhoto &&
        this.item.mediaAssets.thumbnailPhoto.url
        ? this.item.mediaAssets.thumbnailPhoto.url
        : this.placeholder;
    },
    isTrainer() {
      return (
        this.roles && this.roles.length > 0 && this.roles[0] === 'isTrainer'
      );
    },
  },
  created() {
    this.selectInitialCircuit();
  },
  mounted() {
    this.selectInitialCircuit();
  },
  methods: {
    selectInitialCircuit() {
      if (this.$route.name === 'circuits' || this.selectedCircuit) {
        this.selectedIndex = 0;
      }
    },
    handleClick(item, i) {
      this.selectedIndex = i;
      this.$emit('select-minimal-list-item', item);
    },
    isSelected(item) {
      return (
        (this.selectedCircuit &&
          this.selectedCircuit._id &&
          item &&
          item._id &&
          this.selectedCircuit._id === item._id) ||
        (this.selectedCircuit &&
          this.selectedCircuit.newCircuit &&
          item &&
          item.newCircuit &&
          this.selectedIndex === 0)
      );
    },
  },
  watch: {
    items(newVal, oldVal) {
      if (this.$route.name === 'circuits') {
        if (newVal && oldVal && newVal.length > oldVal.length) {
          this.selectedIndex = 0;
        }
        if (newVal && oldVal && newVal.length < oldVal.length) {
          this.selectedIndex = newVal.length - 1;
        }
      }
    },
    selectedCircuit(val) {
      if (val && val.newCircuit) {
        this.selectedIndex = 0;
      }
    },
  },
};
</script>

<template>
  <ul :class="['list-minimal', type]">
    <li
      v-for="(item, i) in items"
      :class="[
        'list-minimal-item',
        { mine: !isTrainer || (isTrainer && item.trainer_id !== '0') },
        { selected: isSelected(item) },
      ]"
      :key="i"
      @click="handleClick(item, i)"
    >
      <BaseThumbnail
        :image="thumbnailPhoto"
        v-if="showThumbnail && thumbnailPhoto"
      />
      <span
        :class="[
          'list-minimal-item-title',
          {
            newCircuit:
              (item && item.newCircuit && selectedCircuit.label === '') ||
              (selectedCircuit &&
                !selectedCircuit.newCircuit &&
                item &&
                item.newCircuit) ||
              (item && item.newCircuit && selectedIndex !== 0),
          },
        ]"
      >
        {{
          !item.newCircuit
            ? item.label
            : selectedIndex === 0 &&
              selectedCircuit &&
              selectedCircuit.label !== '' &&
              selectedCircuit &&
              selectedCircuit.newCircuit
            ? selectedCircuit.label
            : 'New Circuit'
        }}
      </span>
      <img src="@assets/images/icon-chevron-right.svg" v-if="showIcon" />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.list-minimal {
  margin-bottom: 0;

  .list-minimal-item {
    align-items: center;
    border-bottom: 1px solid $color-light-gray;
    display: flex;
    justify-content: space-between;
    padding: 2.1rem 1.7rem 2.1rem 3.6rem;
    transition: background-color $duration-animation-base ease-in-out;

    &:first-child {
      border-top: 1px solid $color-light-gray;
    }
    &.selected {
      background-color: $color-off-white;
    }

    &:hover {
      background-color: $color-off-white;
      cursor: pointer;
    }

    &:focus {
      background-color: $color-off-white;
      outline: none;
    }
  }

  .list-minimal-item-title {
    color: $color-heading-text;
    font-size: 16px;
    font-weight: 800;
    line-height: 22px;
    &.newCircuit {
      color: rgba($color-heading-text-wo-rgb, 0.4);
    }
  }

  &.lite {
    .list-minimal-item {
      justify-content: flex-start;
      padding: 0.8rem 0;

      &:last-child {
        border-bottom: 1px solid $color-light-gray;
      }

      .list-minimal-item-title {
        font-size: 1.4rem;
        font-weight: 600;
        letter-spacing: 0.116667px;
        line-height: 2.5rem;
      }

      .image-thumbnail {
        align-items: center;
        display: flex;
        margin-right: 1.8rem;
        width: 9rem;
      }
    }
  }
}
</style>
